module.exports = __webpack_public_path__ + "static/media/image5.d1504e14.JPG";